function TimePicker(id, inputField){
	this.id = id;
    this.inputField = inputField ? ge(inputField) : text();
    this.inputField.size = 10;
    this.disabled = false;
    this.hrs = [];
    this.currentHrs = 0;
    this.amPm = [];
    this.currentAmPm = 0;
    this.mins = [];
    this.currentMins = 0;

    this.inputField.onclick = this.clicked.bind(this);

    document.body.appendChild(this.pickerView = div('timePicker drop-down',[
        div('timeHrs',[
            this.hrs[0] = span('pickerHrs norm', '12', {'click':this.hourClicked.bind(this,0)}),
            this.hrs[1] = span('pickerHrs norm', '1', {'click':this.hourClicked.bind(this,1)}),
            this.hrs[2] = span('pickerHrs norm', '2', {'click':this.hourClicked.bind(this,2)}),
            this.hrs[3] = span('pickerHrs norm', '3', {'click':this.hourClicked.bind(this,3)}),
            this.hrs[4] = span('pickerHrs norm', '4', {'click':this.hourClicked.bind(this,4)}),
            this.hrs[5] = span('pickerHrs norm', '5', {'click':this.hourClicked.bind(this,5)}),
            this.hrs[6] = span('pickerHrs norm', '6', {'click':this.hourClicked.bind(this,6)}),
            this.hrs[7] = span('pickerHrs norm', '7', {'click':this.hourClicked.bind(this,7)}),
            this.hrs[8] = span('pickerHrs norm', '8', {'click':this.hourClicked.bind(this,8)}),
            this.hrs[9] = span('pickerHrs norm', '9', {'click':this.hourClicked.bind(this,9)}),
            this.hrs[10] = span('pickerHrs norm', '10', {'click':this.hourClicked.bind(this,10)}),
            this.hrs[11] = span('pickerHrs norm', '11', {'click':this.hourClicked.bind(this,11)})
        ]),
        div('timeAmPm',[
            this.amPm[0] = span('pickerAmPm norm', 'AM', {'click':this.amPmClicked.bind(this,0)}),
            this.amPm[1] = span('pickerAmPm norm', 'PM', {'click':this.amPmClicked.bind(this,1)})
        ]),
        div('timeMins',[
            this.mins[0] = span('pickerMins norm', '00', {'click':this.minClicked.bind(this,0)}),
            this.mins[1] = span('pickerMins norm', '05', {'click':this.minClicked.bind(this,1)}),
            this.mins[2] = span('pickerMins norm', '10', {'click':this.minClicked.bind(this,2)}),
            this.mins[3] = span('pickerMins norm', '15', {'click':this.minClicked.bind(this,3)}),
            this.mins[4] = span('pickerMins norm', '20', {'click':this.minClicked.bind(this,4)}),
            this.mins[5] = span('pickerMins norm', '25', {'click':this.minClicked.bind(this,5)}),
            this.mins[6] = span('pickerMins norm', '30', {'click':this.minClicked.bind(this,6)}),
            this.mins[7] = span('pickerMins norm', '35', {'click':this.minClicked.bind(this,7)}),
            this.mins[8] = span('pickerMins norm', '40', {'click':this.minClicked.bind(this,8)}),
            this.mins[9] = span('pickerMins norm', '45', {'click':this.minClicked.bind(this,9)}),
            this.mins[10] = span('pickerMins norm', '50', {'click':this.minClicked.bind(this,10)}),
            this.mins[11] = span('pickerMins norm', '55', {'click':this.minClicked.bind(this,11)})
        ])
    ]));

    this.dropdown = Dialog.Popup(this.id, this.pickerView).sticky();
    this.updateField();
}

TimePicker.prototype = {
    setVisible: function(val){
        this.inputField.style.visibility = val ? 'visible' : 'hidden';
    },
    clicked: function(event){
        if (this.disabled) return;
        this.dropdown.handle(this.inputField, event);
        this.inputField.blur();
    },
    hourClicked : function(val) {
        if (this.setHrs(val) && this.cb) this.cb();
    },
    amPmClicked: function(val) {
        if (this.setAmPm(val) && this.cb) this.cb();
    },
    minClicked: function(val) {
        if (this.setMin(val) && this.cb) this.cb();
    },
    setHrs: function(val){
        style(this.hrs[this.currentHrs]);
        this.currentHrs = val;
        style(this.hrs[this.currentHrs], 'hiLt');
        this.updateField();
        return true;
    },
    setAmPm: function(val){
        style(this.amPm[this.currentAmPm]);
        this.currentAmPm = val;
        style(this.amPm[this.currentAmPm], 'hiLt');
        this.updateField();
        return true;
    },
    setMin: function(val){
        style(this.mins[this.currentMins]);
        this.currentMins = val;
        style(this.mins[this.currentMins], 'hiLt');
        this.updateField();
        this.dropdown.close();
        return true;
    },
    updateField: function () {
        this.inputField.value = this.disabled ?
            '-- : --' :
            MinsPast(
                (this.currentAmPm ? this.currentHrs + 12 : this.currentHrs),
                this.currentMins * 5
            );
    },
    getInputElem: function(){
        return this.inputField;
    },
    getTime: function(){
        return (this.currentAmPm ? this.currentHrs + 12 : this.currentHrs)*60 + this.currentMins*5;
    },
    getMillis: function() {
        return this.getTime() * 60000;
    },
	setTime: function(time){
        var hrs, mins;
        if (time > 24*60){
            // time is utc seconds
            var dt = new Date(time);
            hrs = dt.getUTCHours();
            mins = dt.getUTCMinutes();
        } else {
            // time is minutes in the day
            hrs = Math.floor(time/60);
            mins = (time%60);
        }
        this.setHrs(hrs > 11 ? hrs - 12 : hrs);
        this.setAmPm(hrs > 11 ? 1:0);
        this.setMin(Math.floor(mins/5));
	},
	setCloseCB: function (callback, callbackObj) {
        this.cb = (typeof(callbackObj) === 'undefined') ? callback : callback.bind(callbackObj);
	},
    setEnabled: function(value) {
        this.disabled = !value;
        this.inputField.disabled = this.disabled;
        this.updateField();
    }
};